// useEventBus — Isomorphism Phase 3 hook
//
// Provides a typed Event Bus instance via React context (singleton).
// Components subscribe to events via useEventBus().on() in useEffect.
//
// Isomorphism mapping:
//   - Blind Spot 2 (async communication formalization)
//   - tech-decisions.md §1 Layer 4 "Event bus (组件间通信，禁止直接调用)"

import { createContext, useContext } from 'react';
import { createEventBus, type IEventBus } from '../event-bus.js';

/** Singleton Event Bus instance — one per app lifetime. */
export const eventBusInstance = createEventBus();

const EventBusCtx = createContext<IEventBus>(eventBusInstance);

export const EventBusProvider = EventBusCtx.Provider;

export function useEventBus(): IEventBus {
  return useContext(EventBusCtx);
}
